<template>
    <div class="bg-box">
        <div class="bg-img"></div>
        <div class="bg-img"></div>
        <div class="bg-img"></div>
        <div class="bg-img"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    created(){

    },
    methods:{

    }
};
</script>

<style lang="scss" scoped>
.bg-box{
    display:flex;
    position: absolute;
    top:-5.2vw;
    left:-2vw;
    right:-2vw;
    z-index: -1;
    bottom: 0;
    /*background: url("~@/assets/images/student-card.png") 0% 0%/26vw auto repeat-y,
    url("~@/assets/images/student-card.png") 33.3333% 66.66666%/26vw auto repeat-y,
    url("~@/assets/images/student-card.png") 66.66666% 33.33333%/26vw auto repeat-y,
    #F1AA55 url("~@/assets/images/student-card.png") 100% 100%/26vw auto repeat-y;*/
}
.bg-img{
    width:26vw;
    height:100%;
    background: #F1AA55 url("~@/assets/images/student-card.png") repeat-y;
    background-size: contain;
}
.bg-img:nth-child(1){
    background-position:0% 0%;
}
.bg-img:nth-child(2){
    background-position:0% 66.66666%;
}
.bg-img:nth-child(3){
    background-position:0% 33.33333%;
}
.bg-img:nth-child(4){
    background-position:0% 100%;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .bg-img{
        width:34.67vw;
    }
    .bg-img:nth-child(1){
        background-position:0% 0%;
    }
    .bg-img:nth-child(2){
        background-position:0% 50%;
    }
    .bg-img:nth-child(3){
        background-position:0% 100%;
    }
    .bg-img:nth-child(4){
       display: none;
    }
}
</style>